var map = {
	"./404.svg": "0VJI",
	"./app.svg": "dYmR",
	"./categoray.svg": "hPNL",
	"./function.svg": "tNxQ",
	"./live.svg": "rPQe",
	"./machine.svg": "+Mmo",
	"./main.svg": "Kbpm",
	"./mmachine.svg": "Fe9T",
	"./mresource.svg": "EQc0",
	"./password.svg": "74Gh",
	"./place.svg": "i+qC",
	"./resource.svg": "BDrC",
	"./respac.svg": "sybz",
	"./role.svg": "sxzF",
	"./soft.svg": "oGf7",
	"./special.svg": "Cm2Q",
	"./stats.svg": "uUq3",
	"./system.svg": "fkAr",
	"./user.svg": "EOg8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7r+V";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg \.svg$
// module id = 7r+V
// module chunks = 6